<template>
    <jc-drawer v-model="open" class="search-drawer-wrapper">
      <div class="search-drawer" @touchmove="handleTouch">
        <div class="search-drawer-header" ><i @click.stop="open = false" class="jc-icon icon-cancel"></i></div>
        <div class="search-drawer-body">
          <div class="searchbar">
              <van-search
                v-model="keyword"
                placeholder="搜索"
                show-action/>
            <!-- <i class="tender-icon icon-search"/>
            <input class="search-input" placeholder="搜索"/><span class="cancel-text">取消</span> -->
          </div>
          <div class="filters">
              <slot/>
          </div>
        </div>
        <div class="search-drawer-footer">
          <button class="btn half" type="button" @click.stop="handleReset">重置</button>
          <button class="btn primary half" type="button" @click.stop="handleConfirm">确认</button>
        </div>
      </div>
    </jc-drawer>
</template>

<script>
import debounce from 'lodash.debounce'
import scrollLocker from '@/utils/scroll-lock'
export default {
  name: 'search-drawer',
  props: {
    value: Boolean,
    sort: {
      type: Boolean,
      default: false // 是否按序显示选中内容
    },
    separator: {
      type: String,
      default: ';'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open () {
      if (!this.open) {
        scrollLocker.unlock()
        this.$emit('input', false)
      } else {
        this.items.forEach(item => {
          item.initHeight()
        })
        scrollLocker.lock()
      }
    }
  },
  data () {
    return {
      open: false,
      items: [],
      currentValues: [],
      keyword: ''
    }
  },
  methods: {
    handleTouch (e) {
      // 阻止滚动穿透 配置Locker
      e.stopPropagation()
    },
    handleConfirm () {
      let ret = {}
      this.currentValues.forEach(val => {
        ret[val.name] = val.values
      })
      // 构造返回参数
      this.items.forEach(item => {
        if (!ret[item.name]) ret[item.name] = []
        if (item.data.length === ret[item.name].length) {
          ret[item.name] = ''
        } else {
          ret[item.name] = JSON.parse(JSON.stringify(ret[item.name].map(ii => ii.value).join(this.separator)))
        }
      })
      this.$emit('confirm', ret, this.keyword)
      setTimeout(() => {
        this.open = false
      }, 20)
    },
    handleReset () {
      this.keyword = ''
      this.items.forEach(item => {
        this.clearItem(item)
      })
    },
    clearItem (item) {
      item.clearValues && item.clearValues()
    },
    onChange (name, values) {
      if (name) {
        let index = this.items.findIndex(item => item.name === name)
        if (index !== -1) {
          let __index = this.currentValues.findIndex(
            item => item.name === name
          )
          if (__index !== -1) {
            if (this.items[index].values && this.items[index].values.length) {
              this.currentValues[__index] = this.items[index]
            } else this.currentValues.splice(__index, 1)
            this.__sort()
            this.debounce.cancel()
            this.debounce()
          } else {
            if (this.items[index].values && this.items[index].values.length) {
              this.currentValues.push(this.items[index])
              this.__sort()
              this.debounce.cancel()
              this.debounce()
            }
          }
        }
      }
    },
    emitChange () {
      let ret = {}
      this.currentValues.forEach(val => {
        ret[val.name] = val.values
      })
      this.$emit('change', ret)
    },
    __sort () {
      if (this.sort) {
        this.currentValues.sort((v1, v2) => {
          if (v1.sort > v2.sort) return 1
          else if (v1.sort < v2.sort) return -1
          else return 0
        })
      }
    }
  },
  created () {
    this.debounce = debounce(this.emitChange, 500, {maxWait: 1000})
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/variable.scss";
.search-drawer-wrapper {
  width: 664px;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
// 筛选框
.search-drawer {
  position: relative;
  height: 100%;
  width: 100%;
  font-size: 0;
  &-header {
    height: 100px;
    width: 100%;
    padding: 0 20px;
    font-size: 30px;
    color: $black_text;
    z-index: 1999;
    display: flex;
    align-items: center;
    i {
      font-size: 40px;
    }
  }
  &-body {
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    top: 100px;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 0 0px 150px 0px;
    font-size: 20px;
    z-index: 1998;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .searchbar {
      width: 100%;
      position: relative;
      .search-input {
        height: 50px;
        width: 566px;
        border: 1px solid #bfbfc0;
        border-radius: 36px;
        background: #f2f2f2;
        outline: none;
        font-size: 24px;
        margin: 0;
        resize: none;
        padding-left: 66px;
        padding-right: 30px;
        box-sizing: border-box;
      }
      .icon-search {
        position: absolute;
        top: 50%;
        left: 26px;
        transform: translateY(-50%);
      }
      .cancel-text {
        color: $primary;
        font-size: 24px;
        text-align: right;
        display: inline-block;
        width: calc(100% - 566px);
      }
    }
    .filters {
    // padding: 0 30px;
      &-item {
        margin-top: 26px;
        font-size: 24px;
        .filters-item-title {
          height: 60px;
          box-sizing: border-box;
          padding-bottom: 20px;
          padding-left: 31px;
          padding-right: 31px;
          @include clearfix;
          .title {
            font-weight: bold;
          }
          .all {
            float: right;
            * {
              vertical-align: middle;
            }
            &.active {
              color: $primary;
            }
            i {
              margin-left: 5px;
              display: inline-block;
            }
          }
        }
        .filter-items {
          @include clearfix;
          overflow: hidden;
          // transition: height 0.3s linear;
          li {
            float: left;
            width: 160px;
            height: 60px;
            // line-height: 60px;
            background: #f2f2f2;
            color: $black_text;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            padding: 0 10px;
            border-radius: 4px;
            font-size: 24px;
            margin: 0 30.679999px;
            margin-bottom: 10px;
            &.active {
              background: $primary;
              color: #fff;
            }
            span {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            &:nth-child(3n - 1) { // 这种方案单选存在Bug，没找到原因
              // margin-left: 62px!important;
              // margin-right: 62px!important;
            }
          }
        }
      }
    }
  }
  &-footer {
    position: absolute;
    left: 0;
    bottom: 0;
    background: #fff;
    height: 100px;
    width: 100%;
    border-top: 2px solid #e7e7e7;
    z-index: 199999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search-drawer/drawer.vue